export default __webpack_public_path__ + "static/media/google-login.51d227ed.svg";